import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import {
  selectUserCohort,
  selectUserSubscriptionInfo,
} from 'root-redux/selects/user'

import { formatPrice } from 'helpers/formatPrice'
import { getSubscriptionUIStatus } from 'helpers/getSubscriptionUIStatus'

import { getBillingPeriodTranslation } from 'modules/unsubscribe/helpers'

import { SubscriptionContainer as Container } from 'common-styles'
import { WELLHUB_COHORT } from 'root-constants'

import { StyledSubscriptions as S } from './Subscriptions.styles'
import { STATUSES_TEXT_MAP, SUBSCRIPTION_DETAILS_MAP } from './constants'

export const MainSubscriptionRows: React.FC = () => {
  const { t } = useTranslation()
  const userSubscriptionInfo = useSelector(selectUserSubscriptionInfo)
  const userCohort = useSelector(selectUserCohort)
  const { isCanceledSubscription } = getSubscriptionUIStatus(
    userSubscriptionInfo?.uiStatus,
  )

  if (!userSubscriptionInfo) {
    return null
  }

  const isExternalUser = userCohort === WELLHUB_COHORT
  const billingPeriod = getBillingPeriodTranslation(
    userSubscriptionInfo.interval,
    userSubscriptionInfo.intervalCount,
  )
  const SubscriptionDetails =
    SUBSCRIPTION_DETAILS_MAP[userSubscriptionInfo.uiStatus]

  return (
    <>
      <S.SubscriptionRow>
        <span>
          <Trans i18nKey="subscription.status" components={[<br />]} />
        </span>
        <S.Status status={userSubscriptionInfo.uiStatus}>
          <Trans
            i18nKey={STATUSES_TEXT_MAP[userSubscriptionInfo.uiStatus]}
            components={[<br />]}
          />
        </S.Status>
      </S.SubscriptionRow>

      {SubscriptionDetails && <SubscriptionDetails />}

      {!isCanceledSubscription && !isExternalUser && (
        <>
          <S.Separator />
          <S.SubscriptionRow>
            <span>{t('subscription.billingPeriod')}</span>
            <Container.InfoValue>
              {t(billingPeriod.key, { count: billingPeriod.count })}
            </Container.InfoValue>
          </S.SubscriptionRow>
          <S.SubscriptionRow>
            <span>{t('subscription.nextChargeDate')}</span>
            <Container.InfoValue>
              {userSubscriptionInfo.nextPayment}
            </Container.InfoValue>
          </S.SubscriptionRow>
          <S.SubscriptionRow>
            <span>{t('subscription.subscriptionPrice')}</span>
            <Container.InfoValue>
              {t('subscription.priceAmount', {
                currency: userSubscriptionInfo.currencySymbol,
                amount: formatPrice(
                  userSubscriptionInfo.subAmount || userSubscriptionInfo.price,
                  userSubscriptionInfo.currency,
                ),
              })}
            </Container.InfoValue>
          </S.SubscriptionRow>
        </>
      )}
    </>
  )
}
